@let
c = content();

<div class="dialog-container">
	<app-ui-video-bg></app-ui-video-bg>
	<div class="dialog-inner">
		<div class="dialog-inner-clip">
			@if (c) {
				@if (c.title.length > 0) {
					<div class="dialog-title">{{c.title}}</div>
				}
				@for (
						d of c.descr; track d + $index) {
					<div class="dialog-descr">{{d}}</div>
				}
			}
			<div class="dialog-block">
				<ng-content></ng-content>
			</div>
		</div>
	</div>
</div>